<script setup lang="ts">
import { formatTimeAgoIntl } from '@vueuse/core'
const { isCommonNotificationsSlideoverOpen } = useDashboard()

const n = useNotification();
const notifications = n.notifications;

const filteredNotifications = computed(() => {
  return notifications.value.filter(n => n.labelStatus === 'necitit')
})

function truncateHtml(html: string, maxLength: number): string {
  const div = document.createElement("div");
  div.innerHTML = html;

  let result = "";
  let length = 0;

  function walk(node: Node) {
    if (length >= maxLength) return;

    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.nodeValue || "";
      const remaining = maxLength - length;

      if (text.length <= remaining) {
        result += text;
        length += text.length;
      } else {
        result += text.slice(0, remaining) + "...";
        length = maxLength;
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const el = node as HTMLElement;
      const tagName = el.tagName.toLowerCase();

      result += `<${tagName}${[...el.attributes]
        .map(a => ` ${a.name}="${a.value}"`)
        .join("")}>`;

      for (const child of Array.from(node.childNodes)) {
        walk(child);
        if (length >= maxLength) break;
      }

      result += `</${tagName}>`;
    }
  }

  for (const child of Array.from(div.childNodes)) {
    walk(child);
    if (length >= maxLength) break;
  }

  return result;
}


const formatRo = (date: string) =>
  formatTimeAgoIntl(new Date(date), {
    locale: 'ro-RO',
  })

const markAllNotificationsAsRead = async () => {
  await n.markAllAsRead();
  isCommonNotificationsSlideoverOpen.value = false;
}
</script>

<template>
  <USlideover v-model:open="isCommonNotificationsSlideoverOpen">
    <template #title>
      <div class="flex items-center gap-2">
        <span>Notificări</span>
        <UKbd variant="subtle">N</UKbd>
      </div>
    </template>
    <template #body>
      <TransitionGroup tag="div" enter-active-class="transition duration-300 ease-out"
        enter-from-class="opacity-0 translate-x-12" enter-to-class="opacity-100 translate-x-0"
        leave-active-class="transition duration-200 ease-in absolute" leave-from-class="opacity-100 translate-x-0"
        leave-to-class="opacity-0 translate-x-12">
        <NuxtLink v-for="notification in filteredNotifications" :key="notification.key"
          :to="`/profil?tab=notifications&id=${notification.key}`"
          class="px-3 py-2.5 rounded-md hover:bg-elevated/50 flex items-center gap-3 relative -mx-3 first:-mt-3 last:-mb-3"
          @click="isCommonNotificationsSlideoverOpen = false">
          <UChip color="error" :show="notification.labelStatus !== 'citit'" inset>
            <UAvatar :alt="'System'" size="md" />
          </UChip>

          <div class="text-sm flex-1">
            <p class="flex items-center justify-between">
              <span class="text-highlighted font-medium">{{ 'System' }}</span>

              <time :datetime="notification.date_created" class="text-muted text-xs"
                v-text="formatRo(notification.date_created)" />
            </p>

            <p class="text-dimmed">
              {{ notification.subject }}
            </p>
          </div>
        </NuxtLink>
      </TransitionGroup>
    </template>
    <template #footer>
      <div class="flex w-full">
        <div class="ml-auto">
          <UButton icon="i-lucide-mail" label="Marchează toate ca citite" variant="ghost" color="neutral"
            @click="markAllNotificationsAsRead" />
        </div>
      </div>
    </template>
  </USlideover>
</template>
